import Enum from '../interfaces/IEnum';

export const LegalTextTypes: Enum = {
    translations: {
        0: 'lang.legalTexts.termsLegalText',
        1: 'lang.legalTexts.protectionLegalText',
        2: 'lang.shared.authorizations'
    },
    enum: {
        TERMS: 0,
        PROTECTION: 1,
        AUTHORIZATIONS: 2
    }
};
